import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink, Main } from '../../components';
import Page from '../../containers/Page';
import useClasses from '../../hooks/useClasses';
import useRoutes from '../../hooks/useRoutes';
import OnboardingHtiForm from './Form';

import '../Onboarding/style.scss';

// This is onboarding page for the new HTI flow (updating user).
const OnboardingHti: React.FC = () => {
  const { t } = useTranslation();
  const { onboarding } = useRoutes();
  const { buildClass, joinClasses } = useClasses('PageOnboarding', 'PageOnboarding--hti');

  return (
    <Page className={buildClass()} hideChrome hideMenuMain title={t('pages.onboarding_credentials_hti.title')}>
      <Container>
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3 py-4 py-md-12">
            <header className={buildClass('header')}>
              <CoreLink
                to={onboarding.checklistHti}
                title={t('buttons.back')}
                className="icon-before icon-chevron icon-orientation-left"
              />
            </header>

            <Main className={buildClass('content')}>
              <h1 className={buildClass('title')}>
                {t('pages.onboarding_credentials_hti.title')}
              </h1>
              <p className={joinClasses(buildClass('body'), 'body--large')}>
                {t('pages.onboarding_credentials_hti.body')}
              </p>

              <OnboardingHtiForm />
            </Main>
          </div>
        </div>
      </Container>
    </Page>
  );
};

export default OnboardingHti;
